import React, { useState } from 'react';
import { useEffect } from "react";
import { FlatList, Image, View } from "react-native";
import { useDispatch, useSelector } from "react-redux"
import { Text, TouchableOpacity } from '../../../globalComponents/NativeOverrides';
import { PlayerFilterProps } from '../../../store/types/mk_svc';
import { market_getOrderFiltersByPlayerId } from '../../../store/actionsv1/markets';
import { PublicPlayerProps } from '../../../store/types/auth_svc';
import Colors from '../../../constants/Colorsv2';
import { Icon } from 'react-native-elements';


type StarredFiltersCardProps = {
    onFilterSelect: (pf:PlayerFilterProps) => void,
    onManage: () => void
}

const StarredFiltersCard = ({ onFilterSelect, onManage }: StarredFiltersCardProps ) => {
    const [ loading, setLoading ] = useState(false);
    const dispatch = useDispatch();

    const player:PublicPlayerProps|undefined = useSelector((state:any) => state.player.player, (left, right) => left?.player_id == right?.player_id);
    const app_size:{ width:number } = useSelector((state:any) => state.util.app_size, (left, right) => left.width == right.width);
    const player_filters:PlayerFilterProps[] = useSelector((state:any) => state.market.player_filters.filter(pf => pf.status != 'deleted'), (left, right) => {
        if(left.length != right.length){ return false }
        if(left.filter(f => f.pinned).length != right.filter(f => f.pinned).length) { return false }
        return true
    });
    const starred_filters = player_filters.filter(pf => pf.pinned);

    useEffect(() => {
        if(!player?.player_id){ return }
        getFiltersFromServer(player.player_id)
    },[player?.player_id])

    const getFiltersFromServer = async(player_id:string) => {
        setLoading(true);
        await dispatch(market_getOrderFiltersByPlayerId(player_id, 'active'))
        setLoading(false);
    }

    const renderFilters = (data:{ item:PlayerFilterProps, index:number }) => {
        return (
            <TouchableOpacity style={{ padding:10, flexDirection:'row', alignItems:'center', borderBottomWidth:1, borderColor:Colors.shades.shade600 }} onPress={() => {
                if(data.item.premium && player?.type != 'premium'){ return alert('Must be premium to run this filter') }
                onFilterSelect(data.item)
                }}>
                <View style={{ flex:1 }}>
                    <Text color={Colors.brand.midnight} weight='semibold' textAlign='left'>{data.item.name}</Text>
                    {data.item.premium?
                    <Text style={{ marginTop:2 }} color={Colors.incentive.gold} size={12} weight='semibold'>PREMIUM ONLY</Text>
                    :<></>}
                </View>
                <Icon name='chevron-right' type='feather' color={Colors.brand.midnight} size={18} />
            </TouchableOpacity>
        )
    }

    if(loading){
        return <></>
    }

    if(player_filters.length == 0){
        return (
            <TouchableOpacity style={{ justifyContent:'center', alignItems:'center', padding:10 }} onPress={() => onManage()}>
                <Image
                    source={{ uri: 'https://res.cloudinary.com/hoabts6mc/image/upload/v1700581466/bet_match_cta_qckrzq.webp' }}
                    style={{ width: (app_size.width - 20), height: (app_size.width - 20)*0.4 }}
                    resizeMode='cover'
                />
            </TouchableOpacity>
        )
    }



    return (
        <View nativeID='bet_match' style={{ paddingBottom:10 }}>
            <View style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.brand.midnight }}>
                <Text style={{ flex:1, paddingLeft:10 }} size={16} weight='semibold' color={Colors.shades.white}>Bet Match Filters</Text>
                <TouchableOpacity style={{ flexDirection:'row', alignItems:'center', padding:7, paddingLeft:12, paddingRight:12, margin:8, borderRadius:22, backgroundColor:Colors.brand.electric }} onPress={() => onManage()}>
                    <Text style={{ marginRight:5 }} size={14} color={Colors.shades.white} textAlign='center' weight='semibold'>Manage Filters</Text>
                    <Icon name='chevron-right' type='feather' size={14} color={Colors.shades.white} />
                </TouchableOpacity>
            </View>
            <View nativeID='player_filters' style={{ marginTop:5 }}>
                <FlatList
                    data={starred_filters}
                    renderItem={renderFilters}
                    keyExtractor={(item) => item.player_filter_id.toString()}
                />
            </View>
        </View>
    )
}

export default StarredFiltersCard